import { Voucher } from "@/shared/core-vouchers";
import { TableProps } from "@/ui/tables/Table";
import { formatDate } from "@/utils/formatDate";
import { Avatar, Button, HStack, Status, Text } from "@chakra-ui/react";
import TruncateText from "@/utils/TruncateText";

const STATE_COLORS: Record<string, string> = {
  Validado: "brand",
  Pendiente: "yellow",
  Anulado: "red",
};

export const VoucherStateBadge = ({ state }: { state?: string }) => {
  const palette = (state && STATE_COLORS[state]) || "gray";
  return (
    <Status.Root colorPalette={palette} fontWeight="medium" fontSize="sm">
      <Status.Indicator />
      <Text as="span" color={`${palette}.fg`}>
        {state ?? "—"}
      </Text>
    </Status.Root>
  );
};

export const CreatorCell = ({ name }: { name?: string }) => {
  if (!name) return <Text color="fg.muted">—</Text>;
  return (
    <HStack gap={2}>
      <Avatar.Root size="2xs" colorPalette="gray" variant="subtle">
        <Avatar.Fallback name={name} />
      </Avatar.Root>
      <Text>{name}</Text>
    </HStack>
  );
};

export const VoucherTableColumns = (
  handleOnClickProducts: (item: Voucher) => void,
  handleToggleEnabled: (voucher: Voucher) => void,
): TableProps<Voucher>["headers"] => {
  return [
    {
      label: "Código",
      itemLabel: (item) => <Text fontWeight="semibold">{item.code}</Text>,
      sortable: true,
      sortKey: "code",
    },
    {
      label: "Tipo de vale",
      itemLabel: (item) => item.voucherType?.name,
      sortable: true,
      sortKey: "voucherType",
    },
    {
      label: "Empresa",
      itemLabel: (item) =>
        item.clientEntity?.name ? (
          <TruncateText maxWidth={220}>{item.clientEntity.name}</TruncateText>
        ) : (
          <Text color="fg.muted">—</Text>
        ),
      sortable: true,
      sortKey: "clientEntity",
    },
    {
      label: "Estado de vale",
      itemLabel: (item) => (
        <VoucherStateBadge state={item.voucherState?.name} />
      ),
    },
    {
      label: "OT",
      itemLabel: (item) =>
        item.workOrder?.name ? (
          <TruncateText maxWidth={200}>{item.workOrder.name}</TruncateText>
        ) : (
          <Text color="fg.muted">No aplica OT</Text>
        ),
      sortable: true,
      sortKey: "workOrder",
    },
    {
      label: "Fecha",
      itemLabel: (item) => formatDate(item.voucherDate.toString()),
      sortable: true,
      sortKey: "createdAt",
    },
    {
      label: "Creado por",
      itemLabel: (item) => <CreatorCell name={item.creator?.name} />,
    },
    {
      label: "Productos",
      itemLabel: (item) => (
        <Button
          size="sm"
          variant="outline"
          onClick={() => handleOnClickProducts(item)}
        >
          Ver productos
        </Button>
      ),
    },
    {
      label: "Estado",
      itemLabel: (item) => (
        <Button
          variant="ghost"
          size="sm"
          colorPalette={item.enabled ? "gray" : "green"}
          color={item.enabled ? "fg.muted" : undefined}
          onClick={() => handleToggleEnabled(item)}
        >
          {item.enabled ? "Deshabilitar" : "Habilitar"}
        </Button>
      ),
    },
  ];
};
